import { GridWidgetService } from '../grid-widget.services';
import { SystemService } from 'common/services/core-services/system.service';
import { GridParams } from 'common/models/utility-models/list-utility.model';
import { DataModel, MetaModel, WidgetModel } from 'common/models/utility-models/base-model';
import { Injectable } from '@angular/core';
import { studentNotificationModel } from 'common/models/page-models/Student Notification/student-assignment-data-model';
import { studentNotificationGridMetaModel } from 'common/models/page-models/Student Notification/student-notification-grid-meta.model';
import { studentNotificationListingModel } from 'common/models/page-models/Student Notification/student-notification-grid-model';
import { studentNotificationGridDataService } from 'common/services/data-services/student/Student notification/student-notification-data.service';

 
@Injectable({
    providedIn: 'root'
})
export class studentNotificationGridWidgetService extends GridWidgetService<studentNotificationModel, studentNotificationListingModel> {
    constructor(protected override ds: studentNotificationGridDataService, protected systemService: SystemService) {
        super(ds);

    }
 
    getMetaModel(): MetaModel {
        const meta = new studentNotificationGridMetaModel().getMetaModel();
        return meta;
    }

   
}